import { render, staticRenderFns } from "./FormItem.vue?vue&type=template&id=fd46e5b4&scoped=true"
import script from "./FormItem.vue?vue&type=script&lang=ts"
export * from "./FormItem.vue?vue&type=script&lang=ts"
import style0 from "./FormItem.vue?vue&type=style&index=0&id=fd46e5b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd46e5b4",
  null
  
)

export default component.exports